// generate random quote

export const getQuote = function () {
  let quotes = require('@/assets/misc/quotes.json')['quotes']
  return quotes[Math.floor(Math.random() * (quotes.length) + 0)]
}
